// LevelUpBanner.js
var LevelUpbanner = pc.createScript('levelUpbanner');

LevelUpbanner.attributes.add("levelUpUI", {type:"entity"});
LevelUpbanner.attributes.add('levelNameTxt', {type : 'entity'});
LevelUpbanner.attributes.add("gameTopBar", {type: "entity"});

LevelUpbanner.prototype.initialize = function() {
    LevelUpbanner.instance = this;
};

LevelUpbanner.prototype.showUI = function (assetName) {

    this.levelNameTxt.element.text = assetName.toUpperCase();
    let popUpBar = this.levelUpUI;
    popUpBar.enabled=true;

    this.levelUpUI.tween(this.levelUpUI.getLocalPosition()).to(new pc.Vec3(0, -20, 0), 2, pc.SineOut).on('complete', function() {}).start();
};

function slideTop() {
    let inputEntity = LevelUpbanner.instance.levelUpUI;
    inputEntity.tween(inputEntity.getLocalPosition()).to(new pc.Vec3(0, 240, 0), 1, pc.SineOut).on('complete', function(){inputEntity.enabled = false; }).start();
}

